// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"tableContainer--a54Br","ant-table":"ant-table--MSfxQ","ant-table-thead":"ant-table-thead--4fBiW","ant-table-tbody":"ant-table-tbody--nFCX5"};